<div class="message-wrapper">
  <img class="no-data-icon" src="/images/warning.png" alt="No Data Icon" />
  <h3 class="no-data-message">{{ message }}</h3>
  <app-button
    class="button"
    variant="primary"
    label="Recargar"
    (onClick)="reload()"
  ></app-button>
</div>
